import { OpaqueToken } from "@angular/core";
import { environment } from '../environments/environment';

export let APP_CONFIG = new OpaqueToken("app.config");
export let PROJECT_CONFIG = new OpaqueToken("app.config");

export class IAppConfig {
    apiEndpoint: string;
    apiFake: string;
    testApiEndpoint: string;
    domain: string;
    client_id: string;
    client_secret: string;
    ggAnaliticsNumber: string;
}

export class IProjectConfig {
    platform_prefix: string;
    news_date_visible: boolean;  // [MS] czy daty mają być widocznew skrzynce
    getPlatform_prefix(element: string){}
}

export const AppConfig: IAppConfig = {    
    
    apiFake: "/api",
    // apiEndpoint: "https://sgcompass.eu/api/web/game/resource",
    // domain: "https://sgcompass.eu/api/web",
    //  apiEndpoint: environment.finalVersion? "https://sgcompass.eu/api/web/game/resource" : "http://test.sgcompass.eu/api/web/game/resource",
    //  testApiEndpoint: environment.finalVersion? "https://sgcompass.eu/api/web/api" : "http://test.sgcompass.eu/api/web/api",
    //  domain: environment.finalVersion? "https://sgcompass.eu/api/web" : "http://test.sgcompass.eu/api/web"

     apiEndpoint: environment.apiLink +"/game/resource",
     testApiEndpoint: environment.apiLink +"/api",
     domain: environment.apiLink,
     client_id: environment.client_id,      
     client_secret: environment.client_secret,  

     ggAnaliticsNumber: environment.googleAnalitics

};

export const ProjectConfig: IProjectConfig = {    
    platform_prefix: "_saint",
    news_date_visible: false,
    getPlatform_prefix(element){
        switch (element) {
            case "login-panel": return this.platform_prefix;
            case "nav": return this.platform_prefix;
            case "countries": return this.platform_prefix;
            default: return "";
        }

    }
};


// WEBPACK FOOTER //
// ./src/app/app.config.ts